// main-pages/Careers.js
import { useRouter } from "next/router";
import Header from "../../components/common/Header";
import CommonBanner2 from "../../components/common/CommonBanner2";
import CareersList from "../careers-list";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";
// import FaqSection from "../../components/common/FaqSection";
// import Footer from "../../components/footer";

const FaqSection = dynamic(() => import("../../components/common/FaqSection"));
const Footer = dynamic(() => import("../../components/footer"));

const parsePage = (value) => {
  const n = parseInt(value || "1", 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
};

const Careers = ({ initialCareers = [], initialTotalPages = 1 }) => {
  const { t } = useTranslation("careers");
  const router = useRouter();
  const lang = router.locale || "en";

  const page = parsePage(router.query.page);

  const faqs = [0, 1, 2, 3].map((i) => ({
    question: t(`careers.faqs.${i}.question`),
    answer: t(`careers.faqs.${i}.answer`),
  }));

  return (
    <>
      <Header />
      <main className="w-full box-border bg-background-color-primary overflow-hidden">
        <CommonBanner2
          name={t("careers.banner.title")}
          breadcrumbProps={{
            labelMap: {
              home: lang === "ar" ? "الرئيسية" : "Home",
              careers: lang === "ar" ? "الوظائف" : "Careers",
            },
            separator: lang === "ar" ? "‹" : ">",
          }}
        />
        <CareersList
          careers={initialCareers}
          loading={false}
          page={page}
          totalPages={initialTotalPages}
        />
        <FaqSection faqs={faqs} />
      </main>
      <Footer />
    </>
  );
};

export default Careers;
